module.exports = __webpack_public_path__ + "img/sp-empty.cfad9ede.png";